<wp-combo-box
  [accessibleLabel]="accessibleLabel"
  [required]="false"
  [showOptional]="false"
  [placeholder]="placeholder"
  [noResultsText]="'No results found'"
  size="sm"
  mode="multiple"
  selectionDisplay="fit-chips"
  fieldSizeMode="fixed"
  [disabled]="false"
  [readonly]="false"
  [open]="false"
  [values]="values"
  [items]="items"
  [maxVisible]="4"
  [maxVisibleChips]="2"
  [openOnFocus]="true"
  [clearQueryOnSelect]="true"
  [clearable]="true"
  [invalid]="false"
  [showSupportingText]="false"
  [includeSupportingTextInSelection]="false"
  (comboBoxChange)="onComboBoxChange($event)">
</wp-combo-box>
